<template>
  <a-layout>
    <TheNavbar />
    <a-layout-content class="main-content">
      <router-view></router-view>
    </a-layout-content>
    
    <!-- 全局协议签署弹窗 -->
    <AgreementModal 
      :open="showAgreementModal"
      @success="handleAgreementSigned"
    />
  </a-layout>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import TheNavbar from "@/components/TheNavbar.vue";
import AgreementModal from "@/components/common/AgreementModal.vue";

const route = useRoute();
const authStore = useAuthStore();
const showAgreementModal = ref(false);

// 检查是否需要显示协议弹窗
const checkAgreementStatus = () => {
  // 如果用户未登录，不显示
  if (!authStore.isAuthenticated || !authStore.user) {
    showAgreementModal.value = false;
    return;
  }
  
  // 如果是测试账户且未签署协议，显示弹窗
  if (authStore.user.is_test_account && !authStore.user.agreement_signed) {
    showAgreementModal.value = true;
  } else {
    showAgreementModal.value = false;
  }
};

// 监听路由变化，确保在任何页面都能拦截
watch(() => route.path, () => {
  checkAgreementStatus();
});

// 监听用户状态变化
watch(() => authStore.user, () => {
  checkAgreementStatus();
}, { deep: true });

// 初始化检查
onMounted(() => {
  checkAgreementStatus();
});

const handleAgreementSigned = () => {
  showAgreementModal.value = false;
  // 签署成功后，刷新用户信息或进行其他操作
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%; // 必须明确高度
  overflow-x: hidden;
  background: #ffffff;
}

#app {
  width: 100%;
  min-height: 100%; // 至少占满一屏
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.main-content {
  flex: 1; // 占据除了 Navbar 之外的所有空间
  padding-top: 56px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.ant-message .ant-message-notice-title,
.ant-notification-notice-title,
.ant-notification-notice-description {
  white-space: pre-line;
}
</style>
